import { createContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

const LoaderInit = {
  showSecond: false,
  showSecondLoader: null,
};

export const SecondLoaderContext = createContext(LoaderInit);

const SecondLoaderContextProvider = ({ children }) => {
  const [showSecond, showSecondLoader] = useState(false);
  const value = useMemo(() => ({ showSecond, showSecondLoader }), [showSecond]);
  return (
    <SecondLoaderContext.Provider value={value}>
      {children}
    </SecondLoaderContext.Provider>
  );
};

SecondLoaderContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SecondLoaderContextProvider;
